// reducers/employee-onboarding/reminder.js

export function reminderHasErrored(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_REMINDER_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function reminderIsLoading(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_REMINDER_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function reminder(state = {}, action) {
  switch (action.type) {
    case 'ONBOARDING_REMINDER_FETCH_DATA_SUCCESS':
      return action.data;
    default:
      return state;
  }
}